import { apiFetch } from '@/lib/api-client';

/**
 * Wire-shape of `GET /api/checkout/sessions/:sessionId/status`
 * (Mini-Commit 6.3). Mirrors
 * `src/checkout/dto/checkout-session-status-response.dto.ts` (cross-
 * repo shape — keep in sync).
 *
 * Used by the D-10 `/checkout/success` route on mount to bypass the
 * polling-baseline heuristic. If `status === 'completed'` the route
 * renders success-state directly using `mode` + `planName` +
 * `packCreditsGranted` from this response. If `status === 'pending'`
 * (rare; production webhook-delay window) the route falls through to
 * the existing `useCheckoutPolling` flow.
 */
export interface CheckoutSessionStatus {
  mode: 'subscription' | 'payment';
  status: 'completed' | 'pending' | 'expired';
  planKey: string;
  planName: string;
  /** Set for completed pack sessions only. */
  packCreditsGranted: number | null;
}

/**
 * Owner-scoped: backend 404s on session-not-found OR ownership
 * mismatch (no info leak). Caller treats both as "invalid session"
 * rendering.
 */
export function fetchCheckoutSessionStatus(sessionId: string): Promise<CheckoutSessionStatus> {
  return apiFetch<CheckoutSessionStatus>(
    `/api/checkout/sessions/${encodeURIComponent(sessionId)}/status`,
  );
}
